import $ from 'jquery';
import XConstants from '../../core/config/Constants';
import {useEffect, useState} from 'react';
import 'datatables.net';
import 'datatables.net-bs4';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import {toast} from 'react-hot-toast';
import {UserService} from "./Service";
import {checkActionPermission, checkPermission} from "../../core/routes/RouteValidator";
import {useSelector} from "react-redux";

const ManageUserRole = () => {
    const user = useSelector((state: any) => state.auth);
    const company = useSelector((state: any) => state.company);
    const [service] = useState(new UserService());
    const navigate = useNavigate();
    const location = useLocation();

    const getItems = () => {
        try {
            $('#items').DataTable().destroy();
        } catch (e) {
            console.log(e);
        }
        let token = localStorage.getItem('token');
        $('#items').DataTable({
            lengthMenu: [10, 20, 50, 100, 500, 1000],
            pageLength: 100,
            processing: true,
            serverSide: true,
            columnDefs: [
                {

                    "render": function (data: string, type: any, row: any) {
                        if (data === 'Active') {
                            return `<p class="badge bg-success p-2 rounded-3">Active</p>`;
                        } else {
                            return `<p class="badge bg-danger p-2 rounded-3">Inactive</p>`;
                        }
                    },
                    "targets": 3
                },
                {

                    "render": function (data: any, type: any, row: string[]) {
                        if (row[3] === 'Active') {
                            return `<button class="btn btn-danger">Deactivate</button>`;
                        } else {
                            return `<button class="btn btn-success">Activate</button>`;
                        }
                    },
                    "createdCell": (td: any, cellData: any, rowData: any, row: any, col: any) => {
                        $(td).click(async (e: any) => {
                            let allowed = checkActionPermission(user, company, 'update')
                            if (!allowed) {
                                toast.error("You don't have permission to perform this action", {});
                                return;
                            }
                            const status = rowData[3] === 'Active' ? 'Inactive' : 'Active'
                            const res = await service.updateRole({
                                id: rowData[5],
                                status: status
                            });
                            if (res) {
                                toast.success("Role updated successfully", {});
                                getItems();
                            }
                        })
                    },
                    "targets": 5
                },
                {

                    "render": function (data: any, type: any, row: any) {
                        return `<button class="btn btn-primary">Details</button>`;
                    },
                    "createdCell": (td: any, cellData: any, rowData: any, row: any, col: any) => {
                        $(td).click((e: any) => {
                            let allowed = checkActionPermission(user, company, 'read')
                            if (!allowed) {
                                toast.error("You don't have permission to perform this action", {});
                                return;
                            }
                            navigate(`${location.pathname}/details/${cellData}`);
                        })
                    },
                    "targets": 6
                },
                {

                    "render": function (data: any, type: any, row: any) {
                        return `<button class="btn btn-danger">Delete</button>`;
                    },
                    "createdCell": (td: any, cellData: any, rowData: any, row: any, col: any) => {
                        $(td).click(async (e: any) => {
                            let allowed = checkActionPermission(user, company, 'delete')
                            if (!allowed) {
                                toast.error("You don't have permission to perform this action", {});
                                return;
                            }
                            const res = await service.updateRole({
                                id: rowData[7],
                                deleted: true
                            });
                            if (res) {
                                toast.success("Role deleted successfully", {});
                                getItems();
                            }
                        })
                    },
                    "targets": 7
                },
            ],
            ajax: {
                url: `${XConstants.baseUrl}/company/user/role/list`,
                type: 'POST',
                contentType: 'application/json',
                headers: {
                    'Authorization': token,
                },
                data: function (d: any) {
                    return JSON.stringify({
                        ...d,
                    });
                },
            },
        });
    };

    useEffect(() => {
        getItems();
    }, []);


    return (
        <>
            <div className="page-header">
                <div className="content-page-header">
                    <h5>Roles & Permission</h5>
                    <div className="list-btn">
                        <ul className="filter-list">
                            <li>
                                <div
                                    className="dropdown dropdown-action"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Download"
                                >
                                    <a
                                        href="#"
                                        className="btn-filters"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
              <span>
                <i className="fe fe-download"/>
              </span>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-end">
                                        <ul className="d-block">
                                            <li>
                                                <a
                                                    className="d-flex align-items-center download-item"
                                                    href="javascript:void(0);"
                                                    download=""
                                                >
                                                    <i className="far fa-file-text me-2"/>
                                                    CVS
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                            {(checkPermission(user, company, '/roles/add')) && <li>
                                <Link className="btn btn-primary" to={'/roles/add'}>
                                    <i className="fa fa-plus-circle me-2" aria-hidden="true"/>
                                    Add Role
                                </Link>
                            </li>}
                        </ul>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="card col-12">
                    <div className="card-body w-100">
                        <div className="table-responsive w-100">
                            <table
                                id="items"
                                className="table datatable  w-100"
                            >
                                <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th>Total Modules</th>
                                    <th>Status</th>
                                    <th>Added Date</th>
                                    <th>Change Status</th>
                                    <th>Edit</th>
                                    <th>Delete</th>
                                </tr>
                                </thead>
                                <tbody>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default ManageUserRole;
